export default "__VITE_ASSET__BBZ0lsph__"